import { render, staticRenderFns } from "./perfil_usuario.vue?vue&type=template&id=36c0a640&scoped=true"
import script from "./perfil_usuario.js?vue&type=script&lang=js&external"
export * from "./perfil_usuario.js?vue&type=script&lang=js&external"
import style0 from "./perfil_usuario.scss?vue&type=style&index=0&id=36c0a640&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c0a640",
  null
  
)

export default component.exports